import { Injectable } from '@angular/core';
import { ConfigService } from '../../../../config/config.service';
import { HttpClient } from '@angular/common/http';
import { CentroCusto } from '../../../../types/CentroCusto.type';

@Injectable({
  providedIn: 'root'
})
export class CentrodecustosService {

  constructor(private configService: ConfigService, private httpClient: HttpClient) { }

  getCentroCustos() {

    return this.httpClient.get<CentroCusto[]>(`${this.configService.getApiUrlRoot()}/centrodecustos/`)

  }

  exportar(){

    return this.httpClient.get(`${this.configService.getApiUrlRoot()}/centrodecustos/relatorios/exportar`, { responseType: 'blob'})
  }
}
